import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./Home.css"

const items = [
    {
        src: '/images/home/slider/image1.jpg',
        altText: 'Slide 1',
        caption: 'Slide 1'
    },
    {
        src: '/images/home/slider/image2.jpg',
        altText: 'Slide 2',
        caption: 'Slide 2'
    },
    {
        src: '/images/home/slider/image3.jpg',
        altText: 'Slide 3',
        caption: 'Slide 3'
    }
];

function Home() {
    const navigate = useNavigate();

    const handleFeatureClick = (section) => {
        // Navigate to Products page with specific tab
        navigate('/Products', { state: { activeTab: section } });
    };

    return (
        <div id="mainHomeContainer">
            <div className="hero-section">
                <div className="hero-content">
                    <h1 className="hero-title">Welcome to WayCup</h1>
                    <p className="hero-subtitle">Your Premium Coffee & Market Experience</p>
                    <div className="hero-image-container">
                        <img 
                            alt="Way Cup Coffee Shop" 
                            src='/images/home/waycupmain.jpeg' 
                            className="hero-image"
                        />
                    </div>
                    <div className="hero-features">
                        <div className="feature-item clickable" onClick={() => handleFeatureClick('1')}>
                            <div className="feature-icon">☕</div>
                            <span>Premium Coffee</span>
                        </div>
                        <div className="feature-item clickable" onClick={() => handleFeatureClick('4')}>
                            <div className="feature-icon">🥪</div>
                            <span>Fresh Sandwiches</span>
                        </div>
                        <div className="feature-item clickable" onClick={() => handleFeatureClick('3')}>
                            <div className="feature-icon">🛒</div>
                            <span>Market Items</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;